import React, {memo} from 'react';
import PropTypes from 'prop-types';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {FeatureManagementTableWrapper, TableText} from './style';
import Loading from '../../../../../components/shared/Utils/Loading';
import PopperActions from '../../../../../components/PopperActions';
import {FlexContainer} from '../../../../../components/layout';
import {SidebarNew} from '../../../../../components/layout/sidebar/styles';
import ButtonMore from '../../../merchants/components/ButtonMore';

const FeatureManagementTable = ({
  headCells,
  items = [],
  loading,
  canRemoveFeature,
  onEditHandle,
  onDeleteHandle,
  onStatusHandle,
  onStatusAvailabilityHandle,
  onAdvancedHandle
}) => {
  if (!items.length && !loading) return <div>Features are not found!</div>;

  return (
    <FeatureManagementTableWrapper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {headCells.map((headCell) => (
                <TableCell key={headCell.id}>{headCell.label}</TableCell>
              ))}
              <TableCell style={{width: '5%'}} />
            </TableRow>
          </TableHead>
          {loading ? (
            <Loading />
          ) : (
            <TableBody>
              {items &&
                items.map((row) => (
                  <TableRow key={row.id} tabIndex={-1}>
                    {headCells.map(({id}) => (
                      <TableCell align='left' key={id}>
                        <FlexContainer className='breakWord'>
                          <TableText>
                            {id === 'description'
                              ? String(row[id] || '')
                              : String(row[id])}
                          </TableText>
                          {id === 'name' && row?.isNewFeature && (
                            <SidebarNew>New</SidebarNew>
                          )}
                        </FlexContainer>
                      </TableCell>
                    ))}
                    <TableCell align='right'>
                      <ButtonMore
                        itemsData={[
                          {
                            title: 'Edit',
                            action: () => onEditHandle(row)
                          },
                          !row.isDefaultForRegularLocation &&
                            row.id !== 'book_a_driver_v2' && {
                              title: !row.enabled
                                ? 'Enable Feature'
                                : 'Disable Feature',
                              action: () => onStatusHandle(row)
                            },
                          {
                            title: !row.isNewFeature
                              ? 'Mark as New'
                              : 'Remove New Mark',
                            action: () => onStatusAvailabilityHandle(row)
                          },
                          {
                            title: !row.IsAdvanced
                              ? 'Mark as Advanced'
                              : 'Remove Advanced Mark',
                            action: () => onAdvancedHandle(row)
                          },
                          canRemoveFeature && {
                            title: 'Delete',
                            action: () => onDeleteHandle(row)
                          }
                        ]}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </FeatureManagementTableWrapper>
  );
};

FeatureManagementTable.propTypes = {
  headCells: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  canRemoveFeature: PropTypes.bool,
  onEditHandle: PropTypes.func.isRequired,
  onDeleteHandle: PropTypes.func,
  onStatusHandle: PropTypes.func.isRequired,
  onStatusAvailabilityHandle: PropTypes.func.isRequired,
  onAdvancedHandle: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

FeatureManagementTable.defaultProps = {
  loading: false,
  canRemoveFeature: false,
  onDeleteHandle: () => {}
};

export default memo(FeatureManagementTable);
